"use client"

// src/contexts/DefaultPropsContexts.ts
import { createContext } from "react";
var DelayDefaultPropsContext = createContext({
  ms: void 0,
  fallback: void 0
});
if (process.env.NODE_ENV === "development") {
  DelayDefaultPropsContext.displayName = "DelayDefaultPropsContext";
}
var SuspenseDefaultPropsContext = createContext({
  fallback: void 0,
  clientOnly: void 0
});
if (process.env.NODE_ENV === "development") {
  SuspenseDefaultPropsContext.displayName = "SuspenseDefaultPropsContext";
}

export {
  DelayDefaultPropsContext,
  SuspenseDefaultPropsContext
};
//# sourceMappingURL=chunk-PJ6VIZI5.js.map